import { vxm } from '@/store.vuex';
import axios from 'axios';
import { Module, mutation, VuexModule, action } from 'vuex-class-component';
@Module({ namespacedPath: 'passport/' })
export class PassportStore extends VuexModule {
  private countryList: Array<any> = [];
  private savedPassportList: Array<any> = [];
  private countryCodeMapping = {};

  public get CountryList() {
    return this.countryList;
  }

  public get SavedPassportList() {
    return this.savedPassportList;
  }

  public get CountryCodeMapping() {
    return this.countryCodeMapping;
  }

  @mutation
  public setCountryList(payload) {
    this.countryList = payload;
  }

  @mutation
  public setCountryCodeMapping(countries) {
    const mapping = {};
    countries.forEach((country) => {
      mapping[country.iso] = country.name;
      mapping[country.iso3] = country.name;
    });
    this.countryCodeMapping = mapping;
  }

  @mutation
  public setSavedPassportList(payload) {
    if (Array.isArray(payload)) {
      payload = payload.map((passport) => {
        if (passport.effectiveDate) {
          passport.effectiveDate = vxm.utility.convertUTCToLocalTime(
            passport.effectiveDate,
          );
        }
        if (passport.expiryDate) {
          passport.expiryDate = vxm.utility.convertUTCToLocalTime(
            passport.expiryDate,
          );
        }
        return passport;
      });
    }
    this.savedPassportList = payload;
  }

  @action({ mode: 'mutate' })
  public async fetchCountryList() {
    const response = await axios.get('/wl-profile-svc/api/v1/isocountries');
    this.setCountryList(response.data.data.countries);
    this.setCountryCodeMapping(response.data.data.countries);
    return response;
  }

  @action({ mode: 'mutate' })
  public async saveSelectedPassport({
    identificationMasterId,
    isPartofRegistration,
  }) {
    const payload: any = { identificationMasterId };
    if (isPartofRegistration) {
      payload.doNotTriggerEvent = 'true';
    }
    var formData = new FormData();
    formData.append('documentInfo', JSON.stringify(payload));
    const response: any = await axios.post(
      '/wl-profile-svc/api/v1/userIdentifications',
      formData,
      {
        headers: {
          Authorization: 'Bearer ' + vxm.users.getToken,
        },
      },
    );
    vxm.passport.fetchSavedPassportList();
    return response.data;
  }

  @action({ mode: 'mutate' })
  public async saveSelectedPassportFile(payload) {
    const response = await axios.post(
      '/wl-profile-svc/api/v1/userIdentifications',
      payload,
      {
        headers: {
          Authorization: 'Bearer ' + vxm.users.getToken,
        },
      },
    );
    vxm.passport.fetchSavedPassportList();
    return response.data;
  }

  @action({ mode: 'mutate' })
  public async fetchSavedPassportList() {
    const response = await axios.get(
      '/wl-profile-svc/api/v1/userIdentifications',
      {
        headers: {
          Authorization: 'Bearer ' + vxm.users.getToken,
        },
      },
    );
    this.setSavedPassportList(response.data.data);
  }

  @action({ mode: 'mutate' })
  public async deletePassport(passport) {
    const response = await axios.post(
      `/wl-profile-svc/api/v1/userIdentifications/${
        passport.userIdentificationId
      }`,
      null,
      {
        headers: {
          Authorization: 'Bearer ' + vxm.users.getToken,
        },
      },
    );
    vxm.passport.fetchSavedPassportList();
    return response.data;
  }

  @action({ mode: 'mutate' })
  public async deletePassportDocument(id) {
    const response = await axios.post(
      `/wl-profile-svc/api/v1/userIdentifications/documents/delete/${id}`,
      null,
      {
        headers: {
          Authorization: 'Bearer ' + vxm.users.getToken,
        },
      },
    );
    vxm.passport.fetchSavedPassportList();
    return response.data;
  }
}
